import { Box, FormControl, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import { useContext, useState } from 'react';

import CommentsWrap from '@/components/comments_components/CommentsWrap';
import { CurrentApplicationContext } from '@/Contexts/CurrentApplicationContext';
import { QuestionProps } from '@/models/Question';
import NoteWithLinks from '../NoteWithLinks';
import RequiredIndicator from '@/components/common/RequiredIndicator';

function SingleSelect({ question }: { question: QuestionProps }) {
  const { canEdit, answers, makingApiRequest, saveApplicationAnswer2 } =
    useContext(CurrentApplicationContext);

  const questionAnswer = answers[question.id];
  const [selected, setSelected] = useState<number | null | undefined>(
    questionAnswer?.choices[0]?.choiceId
  );

  async function handleChanged(event: SelectChangeEvent<number>) {
    setSelected(event.target.value);
    await saveApplicationAnswer2(question, event.target.value);
  }

  return (
    <Box display='flex' width='100%' justifyContent='space-between' alignItems='start'>
      <Box
        display='flex'
        flexDirection='column'
        justifyContent='flex-start'
        gap='4px'
        sx={{
          flex: '1 1 50%',
          maxWidth: '60vw',
          minWidth: '25px',
        }}
      >
        <Typography variant='subtitle1'>
          {question.questionText}
          {question.questionNeeded ? <RequiredIndicator /> : ''}
        </Typography>
        <FormControl
          variant='outlined'
          sx={{ width: 'clamp(10vw, 32vw, 60vw)', maxWidth: '100%' }}
          disabled={!canEdit || makingApiRequest}
          required={question.questionNeeded}
        >
          <Select
            id={`single-select-${question.id}`}
            value={selected != null ? selected : ''}
            onChange={handleChanged}
            error={question.questionNeeded && (selected === null || selected === undefined)}
            displayEmpty
            inputProps={{ 'aria-label': question.questionText }}
          >
            {question.questionChoices?.map((choice) => (
              <MenuItem key={choice.choiceId} value={choice.choiceId}>
                {choice.choice}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {question.questionNote != null && question.questionNote !== '' && (
          <Typography
            color='textSecondary'
            variant='subtitle3'
            sx={{ width: '100%', overflowWrap: 'anywhere' }}
          >
            <NoteWithLinks html={question.questionNote} />
          </Typography>
        )}
      </Box>
      <CommentsWrap question={question} />
    </Box>
  );
}

export default SingleSelect;
